import React, { useEffect } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';

import { trackEvent } from 'helpers/analytics';
import LoadingFullPage from 'components/molecules/LoadingFullPage';
import { SignUp } from './steps/signUp';
import { useOnboarding } from './hooks/useOnboarding';
import { NetworkOnboardingLayout } from './components/networkOnboardingLayout';
import usePageHook from '../../hooks/usePageHook';

import Walkthrough from './walkthrough';

export const Onboarding = () => {
  const { activeNetwork, path, isLoadingCompanyNetwork, params } = useOnboarding();
  usePageHook('Onboarding');

  useEffect(() => {
    if (activeNetwork?.id) {
      trackEvent('admin_onboarding:start', { networkId: activeNetwork.id });
    }
  }, [activeNetwork?.id]);

  if (isLoadingCompanyNetwork) return <LoadingFullPage />;

  if (!activeNetwork) {
    return <Redirect to="/not-found" />;
  }

  return (
    <NetworkOnboardingLayout>
      <Route path={path} exact>
        <SignUp />
      </Route>
      <Switch>
        <Route path={`${path}/onboarding/:step`}>
          <Walkthrough />
        </Route>
        <Route path={`${path}/onboarding`}>
          <Redirect
            to={
              params.employerSlug
                ? `/networks/${activeNetwork.slug}/company/${params.employerSlug}/welcome`
                : `/networks/${activeNetwork.slug}/welcome`
            }
          />
        </Route>
      </Switch>
    </NetworkOnboardingLayout>
  );
};
